<template>
    <div>
        <ModalCommon :id="`configModalActionAppMethods-${config?.id ?? ''}`" :config="config" @save="handleSave()" @close="handleClose()">
            <!-- 応募方法名  -->
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" for="" style="min-width: 80px"
                    >{{ $t('landingPage.settingApplicationMethod.titleAppMethod') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-11">
                    <InputText
                        :model.sync="dataFormAppMethod.title"
                        :config.sync="configFormTitleApp.configFieldTitleAppMethod"
                        @blur="handleValidateField(configFormTitleApp.configFieldTitleAppMethod)"
                    />
                    <div class="mt-3">
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.setSizeText') }}</label>
                            <div class="col-sm-3">
                                <div class="d-flex align-items-center" style="gap: 0.5rem">
                                    <InputText
                                        style="max-width: 120px"
                                        :model.sync="dataFormAppMethod.size_method"
                                        :config.sync="configFormTitleApp.configFieldSizeTitle"
                                    />
                                    <span>px</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.colorText') }}</label>
                            <div class="col-sm-5">
                                <div class="d-flex" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="dataFormAppMethod.color_method"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="dataFormAppMethod.color_method"
                                        :config="{
                                            error: false
                                        }"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                            <div class="col-sm-5">
                                <div class="d-flex" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="dataFormAppMethod.background_method"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="dataFormAppMethod.background_method"
                                        :config="{
                                            error: false
                                        }"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 画像  -->
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" for="" style="min-width: 80px"
                    >{{ $t('landingPage.settingApplicationMethod.image') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-11">
                    <UploadImageCommon
                        :fileValues.sync="dataFormAppMethod.image"
                        @dataFile="handleFileBackgroundEditor"
                        :id="`ImgTitleAppMethods`"
                        :config="{
                            maxSize: 2048
                        }"
                    >
                        <template #warning>
                            <div style="font-size: 13px">
                                {{ $t('noteUploadMaxMB') }}
                            </div>
                        </template>
                    </UploadImageCommon>
                    <div v-if="isRequiredImage" class="invalid-feedback d-block">
                        {{
                            $t('validateField.requiredSelect', {
                                field: $t('landingPage.settingApplicationMethod.image')
                            })
                        }}
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 80px">{{ $t('landingPage.backgroundItem') }}</label>
                <div class="col-sm-5">
                    <div class="d-flex" style="gap: 1rem">
                        <InputText
                            style="min-width: 100px"
                            :model.sync="dataFormAppMethod.background_item"
                            :config="{
                                type: 'color',
                                classCustom: 'form-control-color',
                                error: false
                            }"
                        />
                        <InputText
                            style="max-width: 100px"
                            :model.sync="dataFormAppMethod.background_item"
                            :config="{
                                error: false
                            }"
                        />
                    </div>
                </div>
            </div>
            <!-- ステータス -->
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 80px">{{ $t('landingPage.settingApplicationMethod.status') }} </label>
                <div class="col-sm-11">
                    <div class="d-flex">
                        <div v-for="item in STATUS_APPLICATION_METHODS" :key="item.id + 's'">
                            <InputRadio
                                class="mr-4"
                                :model.sync="dataFormAppMethod.status"
                                :name="`statusTitlePrize`"
                                :id="`statusTitlePrize-${item.id}`"
                                :value="item.value"
                                :label="item.name"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <!-- 詳細が必要 -->
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 80px">{{ $t('landingPage.settingApplicationMethod.detail') }} </label>
                <div class="col-sm-11">
                    <Editor
                        v-if="isVisibleEditor"
                        :id="`configModalActionAppMethods-${config?.id ?? ''}`"
                        :model.sync="dataFormAppMethod.detail"
                        :modelEvents="`change keydown blur focus paste`"
                        :configInit="configEditor"
                        @init="onEditorInit"
                    />
                </div>
            </div>
        </ModalCommon>
    </div>
</template>

<script>
import { InputText, InputRadio } from '@/components/Input';
import { configFormTitleApp, STATUS_APPLICATION_METHODS } from './constants';
import { validateField, validateAllField } from '@/utils/validate';
import { IMAGE_EXTENSIONS } from '@/utils/format';

import ModalCommon from '@/components/Modal/main.vue';
import UploadImageCommon from '@/components/Uploads/Image/main.vue';
import Editor from '@/components/Editor/main.vue';

export default {
    name: 'ModalActionAppMethod',
    components: {
        InputText,
        ModalCommon,
        UploadImageCommon,
        Editor,
        InputRadio
    },
    props: {
        config: {
            type: Object,
            required: true,
            default: () => null
        },
        dataTitle: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    data() {
        return {
            STATUS_APPLICATION_METHODS: STATUS_APPLICATION_METHODS,
            configFormTitleApp: configFormTitleApp,
            dataFormAppMethod: this.dataTitle,
            arrExtension: IMAGE_EXTENSIONS,
            dataFormTitleCopy: JSON.parse(JSON.stringify(this.dataTitle)),
            isVisibleEditor: false,
            isRequiredImage: false,
            objEditor: null,
            configEditor: {
                height: 600
            }
        };
    },
    methods: {
        handleValidateField(configField) {
            validateField(configField);
        },

        handleSave() {
            let checkValidate = validateAllField(configFormTitleApp);
            this.isRequiredImage = !this.dataFormAppMethod.image;
            if (!checkValidate || this.isRequiredImage) return;
            if (this.dataFormAppMethod?.id || (this.dataFormAppMethod?.make_id && this.dataFormAppMethod?.actionTitle == 'Edit')) {
                this.$emit('updateData', this.dataFormAppMethod);
            } else {
                this.dataFormAppMethod.actionTitle = 'Edit';
                this.$emit('addData', this.dataFormAppMethod);
            }
            this.config.model = false;
        },

        handleClose() {
            let { configFieldTitleAppMethod } = this.configFormTitleApp;
            configFieldTitleAppMethod.error = false;
            this.dataFormAppMethod = this.dataFormTitleCopy;
            this.$emit('updateData', this.dataFormAppMethod);
            this.config.model = false;
        },

        renderListLv1(idOrigin, checkIdLv1) {
            return {
                check: idOrigin.id === checkIdLv1,
                itemLv1: idOrigin.data
            };
        },

        handleFileBackgroundEditor() {
            this.isRequiredImage = false;
        },

        onEditorInit(editor) {
            this.objEditor = editor;
        }
    },
    watch: {
        'config.model': {
            handler: function (newShow) {
                if (newShow) {
                    this.dataFormTitleCopy = JSON.parse(JSON.stringify(this.dataTitle));
                    this.isLoading = true;
                    setTimeout(() => {
                        this.isVisibleEditor = true;
                        this.isLoading = false;
                    }, 200);
                } else {
                    this.isVisibleEditor = false;
                }
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
